import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';
import { StateNames } from '../models/vendor.model';
import { ConfigureFormFieldsView } from '../models/ConfigureFormFieldsView';

@Component({
  selector: 'app-parcticipant-details',
  templateUrl: './parcticipant-details.component.html',
  styleUrls: ['./parcticipant-details.component.css','../shared/css/common.css']
})
export class ParcticipantDetailsComponent implements OnInit {

  participantFormData1: any = {};
  participantFormData2: any = {};
  participantFormData3: any = {};
  participantFormData4: any = {};
  payorkey : number;
  title: string = "";
  instructionText!: string | null;
  isInstruction: boolean = false;
  statelist: StateNames[] = [];
  participantFilled = false;

  isformloaded: boolean = false;
  primaryColor?: string = "";
  configureFormFields: ConfigureFormFieldsView[] = [];
  isFormsValid: boolean = false;

  constructor(
    private participantFormBuilder: FormBuilder, 
    private router: Router,
    private referalService: ReferalFormService,
    private cdref: ChangeDetectorRef,
    private vendorService: VendorService,
    private modalService: NgbModal
  ) {
    this.payorkey = parseInt(sessionStorage.getItem("payorkey")?? "0"); 
   }
   participantForm: FormGroup = this.participantFormBuilder.group({});
   participantForm2: FormGroup = this.participantFormBuilder.group({});
   participantForm3: FormGroup = this.participantFormBuilder.group({});
   participantForm4: FormGroup = this.participantFormBuilder.group({});
   formdata : any | null;

  ngOnInit(): void {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata")??"{}"); 
    if(this.formdata && Object.keys(this.formdata).length == 0) {
      this.formdata = this.referalService.getFormLoadJSON();   
      this.participantFormData1["controls"] = this.formdata.participantDetails.controls.slice(0, 3);
      this.participantFormData2["controls"] = this.formdata.participantDetails.controls.slice(3, 4);
      this.participantFormData3["controls"] = this.formdata.participantDetails.controls.slice(4, 7);
      this.participantFormData4["controls"] = this.formdata.participantDetails.controls.slice(7, 14);
      this.participantFilled = this.formdata.participantFilled 
      this.cdref.detectChanges();
      sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));      
      this.loadFormInit(this.payorkey);
    } else {
      this.participantFormData1["controls"] = this.formdata.participantDetails.controls.slice(0, 3);
      this.participantFormData2["controls"] = this.formdata.participantDetails.controls.slice(3, 4);
      this.participantFormData3["controls"] = this.formdata.participantDetails.controls.slice(4, 7);
      this.participantFormData4["controls"] = this.formdata.participantDetails.controls.slice(7, 14);
      this.participantFilled = this.formdata.participantFilled 
      this.loadFormInit(this.payorkey);
    }
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  loadFormInit(payorkey: number){
    this.vendorService.getStateNames().subscribe((result)=>{
      this.statelist = result;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name == "paState").options = result.map(x => {return { "value" : x.Abbreviation, "key" : x.Abbreviation}});
      setTimeout(() => {
        const stateValue = this.participantFormData4.controls.find((x: { name: string; }) => x.name == "paState").value;
        if (stateValue) {
          (this.participantForm4.get('paState') as any)?.setValue(stateValue);
        }
      }, 10);
    });

    this.vendorService.getRequiredFields(payorkey).subscribe((result)=>{    
      if(result != null) {
        this.configureFormFields = result.ConfigureFormFields;
        this.setConfigureFormFields();
      }
      this.participantFormData1.controls.find((x: { name: string; }) => x.name === 'paFirstName').validators.required =result.SpecificMemberFirstName;
      this.participantFormData1.controls.find((x: { name: string; }) => x.name === 'paLastName').validators.required =result.SpecificMemberLastName;
      this.participantFormData1.controls.find((x: { name: string; }) => x.name === 'paID').validators.required =result.SpecificMemberID;
      this.participantFormData2.controls.find((x: { name: string; }) => x.name === 'paDOB').validators.required =result.SpecificMemberDOB;
      this.participantFormData3.controls.find((x: { name: string; }) => x.name === 'paPlanType').validators.required =result.SpecificMemberPlanType;
      this.participantFormData3.controls.find((x: { name: string; }) => x.name === 'paPhone').validators.required =result.SpecificMemberPhoneNumber;
      this.participantFormData3.controls.find((x: { name: string; }) => x.name === 'paEmail').validators.required =result.SpecificMemberEmail;
      this.participantFormData3.controls.find((x: { name: string; }) => x.name === 'paEmail').validators.email = true;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name === 'paAddress1').validators.required =result.SpecificMemberAddress;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name === 'paAddress2').validators.required = false;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name === 'paCity').validators.required =result.SpecificMemberCity;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name === 'paState').validators.required =result.SpecificMemberState;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name === 'paZip').validators.required =result.SpecificMemberZIP;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name === 'paCounty').validators.required = false;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name === 'paCountry').validators.required = false;
      this.participantFormData4.controls.find((x: { name: string; }) => x.name == "paCounty").disabled = true;

      this.vendorService.getLeadPatientsTerm(payorkey).subscribe((list : any)=>{    
        let title = list.find((x: any) => x.Id === result.SelectedPaitentId)?.Title;
        this.title = title;
        this.participantFormData1.controls.find((x: { name: string; }) => x.name === 'paFirstName').label = this.title +" First Name";
        this.participantFormData1.controls.find((x: { name: string; }) => x.name === 'paLastName').label = this.title +" Last Name";
      });

      this.isformloaded = true;
      this.cdref.detectChanges();
      
      if(!this.participantFilled){
        setTimeout(() => {
          let firstName = '';
          let lastName = '';
          let phone = '';
          let email = '';
          let address1 = '';
          let address2 = '';
          let city = '';
          let state = '';
          let zip = '';
          let county = '';
          let country = '';
          
          if(this.formdata.validateParticipant.subcontrols.find((x: { name: any; }) => x.name == "vpIsreferring").value == "Yes"){
            firstName = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "wFirstName")?.value || '';
            lastName = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "wLastName")?.value || '';
            phone = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "phone")?.value || '';
            email = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "email")?.value || '';
            address1 = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "wAddress1")?.value || '';
            address2 = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "wAddress2")?.value || '';
            city = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "city")?.value || '';
            state = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "state")?.value || '';
            zip = this.formdata.extenalReferall.subcontrols.find((x: { name: string; }) => x.name == "zip")?.value || '';
            
            if(state){
              this.vendorService.getStateCounties(state).subscribe((result)=>{
                this.participantFormData4.controls.find((x: { name: string; }) => x.name == "paCounty").options = result.map(x => {return { "value" : x.County, "key" : x.County}});
                this.participantFormData4.controls.find((x: { name: string; }) => x.name == "paCounty").disabled = false;
                this.cdref.detectChanges();
              });
            }
          }
          
          this.participantForm.get('paFirstName')?.setValue(firstName);
          this.participantForm.get('paLastName')?.setValue(lastName);
          this.participantForm3.get('paPhone')?.setValue(phone);
          this.participantForm3.get('paEmail')?.setValue(email);
          this.participantForm4.get('paAddress1')?.setValue(address1);
          this.participantForm4.get('paAddress2')?.setValue(address2);
          this.participantForm4.get('paCity')?.setValue(city);
          this.participantForm4.get('paState')?.setValue(state);
          this.participantForm4.get('paZip')?.setValue(zip);
          this.participantForm4.get('paCounty')?.setValue(county);
          this.participantForm4.get('paCountry')?.setValue(country);
          this.cdref.detectChanges();
        }, 0);
      }
    });

    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result)=>{          
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText =  result.Instruction;
      instructionText = instructionText.replace('<img ','<img title="Header" ')
      this.instructionText = instructionText;
      this.participantForm.valueChanges.subscribe(() => this.formValidate());
      this.participantForm2.valueChanges.subscribe(() => this.formValidate());
      this.participantForm3.valueChanges.subscribe(() => this.formValidate());
      this.participantForm4.valueChanges.subscribe(() => this.formValidate());
      this.formValidate();
    });
  }

  valueChangeEvent(e : any){
    if(e.name == 'paState') {
      this.vendorService.getStateCounties(this.statelist.find( y => y.Id == e.value.target.selectedIndex)?.Abbreviation?? "").subscribe((result)=>{
        this.participantFormData4.controls.find((x: { name: string; }) => x.name == "paCounty").options = result.map(x => {return { "value" : x.County, "key" : x.County}});
      })
      this.participantFormData4.controls.find((x: { name: string; }) => x.name == "paCounty").disabled = false;
    }
    if (e.name === 'paDOB') {
      this.dobValidation();
    }
  }


  
  setConfigureFormFields() {
    let oldMemberId = this.participantFormData1.controls.find((x: { name: string; }) => x.name === 'paID').label;
    let memberId = this.manualFieldConfig('OnlineIntake', 'UIOptions', 'MemberInformation', 'MemberId', oldMemberId);
    this.participantFormData1.controls.find((x: { name: string; }) => x.name === 'paID').label = memberId;
  }

  manualFieldConfig(formCategory: string, formName: string, subFormName: string, fieldName: string, defaultValue: string): string | null {
      let result = defaultValue;
      if(this.configureFormFields != null && this.configureFormFields.length > 0) {
          this.configureFormFields.forEach((field) => {
              if (
                  field.FormCategory && field.FormCategory.toLowerCase() === formCategory.toLowerCase() &&
                  field.FormName && field.FormName.toLowerCase() === formName.toLowerCase() &&
                  field.SubFormName && field.SubFormName.toLowerCase() === subFormName.toLowerCase() &&
                  field.FieldName && field.FieldName.toLowerCase() === fieldName.toLowerCase()
              ) {
                  result = field.LabelValue ?? defaultValue;
              }
          });
      }

      return result;
  }
 
  openInstruction() {
    const result  = this.modalService.open(InstructionsComponent, {size: 'lg',  ariaLabelledBy: 'Instructions'});
    result.componentInstance.name = this.instructionText;
  }

  participantDetailsSubmit() {  
    if (this.participantForm.valid && this.participantForm2.valid && this.participantForm3.valid && this.participantForm4.valid && this.dobValidation()) {
      this.participantFormData1.controls.forEach((control: any) => {
        control.value = this.participantForm.get(control.name)?.value;
      });
      this.participantFormData2.controls.forEach((control: any) => {
        control.value = this.participantForm2.get(control.name)?.value;
      });
      this.participantFormData3.controls.forEach((control: any) => {
        control.value = this.participantForm3.get(control.name)?.value;
      });
      this.participantFormData4.controls.forEach((control: any) => {
        control.value = this.participantForm4.get(control.name)?.value;
      });
      
      var tempArr ={
        controls: []
      }
      tempArr.controls = this.participantFormData1.controls.concat(this.participantFormData2.controls,this.participantFormData3.controls,this.participantFormData4.controls)
      this.formdata.participantDetails = tempArr;
      this.formdata.participantFilled = true;
      sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
      this.router.navigate(['questions']);
    }
  }

  back() {
    this.router.navigate(['validateParticipant']);
  }

  valueChange(data: any) {
    if(data.name == 'paZip') {
      this.participantFormData4.controls.find((x: { name: string; }) => x.name == data.name).value =data.value;
    }
  }

  private dobValidation(): boolean {
    let result = true;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dobCfg = this.participantFormData2.controls.find((x: any) => x.name === 'paDOB');
    const dob = dobCfg && dobCfg.value ? new Date(dobCfg.value) : null;
    let err = '';
    if (dob && dob > today) {
      err = 'Date cannot be in the future.';
      result = false;
    }
    const el = document.getElementById('paDOB_Error');
    if (el) el.textContent = err;
    const ctrl = this.participantForm2.get('paDOB');
    if (ctrl) {
      if (!result) {
        ctrl.setErrors({ ...(ctrl.errors || {}), futureDate: true });
      } else {
        if (ctrl.errors && ctrl.errors['futureDate']) {
          const { futureDate, ...rest } = ctrl.errors;
          Object.keys(rest).length ? ctrl.setErrors(rest) : ctrl.setErrors(null);
        }
      }
    }
    return result;
  }
  formValidate() {
    const allValid = this.participantForm.valid && this.participantForm2.valid && this.participantForm3.valid && this.participantForm4.valid;
    this.isFormsValid = allValid;
  }
}